var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MqlListener } from '../mql-listener';
import { SrOnly } from '../sr-only';
import { DropdownMoreButton } from '../dropdown-more-button';
import { Dropdown } from '../dropdown';
import { DropdownList } from '../dropdown-list';
import { DropdownListSeparator } from '../dropdown-list-separator';
import { DropdownMenu } from '../dropdown-menu';
import { DropdownMenuDivider } from '../dropdown-menu-divider';
import { randomId } from '../lib-randomId';
import { walkToTop } from '../lib-domTraverse';
import { _getElementWidth } from '../lib-itemDisplaying';
import { polyfillCustomEvent } from '../lib-polyfills';
import { resizeListener } from '../lib-resizeListener';
import { classNames } from '../lib-classNames';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
var DEFAULT_DROPDOWN_TARGET_SELECTOR = '[data-e2e="cg-dropdown-toggle"]';
var ButtonGroup = /** @class */ (function (_super) {
    __extends(ButtonGroup, _super);
    function ButtonGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.emit = componentApi.emit.bind(_this);
        _this.writeState = componentApi.writeState.bind(_this);
        _this.buttonGroupContainerRef = React.createRef();
        _this.buttonGroupItemsContainer = React.createRef();
        _this.dropdownContainer = React.createRef();
        _this.cgRequestAnimationFrame = componentApi.cgRequestAnimationFrame.bind(_this);
        _this.toCancel = [];
        _this.cgThrottle = componentApi.cgThrottle.bind(_this);
        _this.templates = [
            { name: 'buttonGroupItem', description: 'The button group item.' },
            {
                name: 'buttonGroupDropdownItem',
                description: 'The button group dropdown item.',
            },
            {
                name: 'buttonGroupDropdownListItem',
                description: 'The button group a11y dropdown item.',
            },
        ];
        _this._dropdownButtonId = '';
        _this._dropdownButtonIdItemsVisible = '';
        _this.mutationObserver = { disconnect: function () { } };
        _this.dropdownButtonWidth = 0;
        _this.renderItemsFrame = null;
        _this.handleResize = _this.cgThrottle(function () {
            _this.setDropdownButtonWidth();
            // We need this because there is some
            // delay when reading new width value from DOM
            // of the mainElement (availableSpace).
            // It also seems to fix the issue in Chrome ActionBar
            // that ActionGroup expanded beyond its parent container.
            cancelAnimationFrame(_this.renderItemsFrame);
            _this.renderItemsFrame = _this.cgRequestAnimationFrame(function () {
                _this.renderItems();
            });
        });
        _this.visibleItemsChange = 'onVisibleItemsChange';
        _this.readTemplate = componentApi.readTemplate.bind(_this);
        _this.state = {};
        _this.state['srLabelId'] = null;
        _this.state['dropdownLeftMarginType'] = 'none';
        _this.state['visibleItemsCount'] = 0;
        _this.state['isDropdownVisible'] = false;
        _this.state['_selectedDropdownItem'] = -1;
        _this.state['itemsLeftMarginTypes'] = [];
        _this.state['isMobile'] = false;
        _this.state['_moreButtonDescriptionId'] = '';
        _this.state['isDropdownWidthCalculated'] = false;
        _this.handleMedia = _this.handleMedia.bind(_this);
        _this.removeSelectedDropdownItem =
            _this.removeSelectedDropdownItem.bind(_this);
        _this.handleDropdownItemSelection =
            _this.handleDropdownItemSelection.bind(_this);
        return _this;
    }
    ButtonGroup.prototype.render = function () {
        var _this = this;
        var _a;
        return (React.createElement("nav", { ref: this.buttonGroupContainerRef, "data-e2e": this.props.dataE2e, "aria-labelledby": this.props.srLabel ? this.state.srLabelId : null, className: 'cg-button-group ' +
                (this.props.mode === 'static' ? 'cg-is-static ' : '') +
                (this.props.mode === 'staticCollapsedOnMobile'
                    ? 'cg-is-static-collapsed-on-mobile '
                    : '') },
            React.createElement(MqlListener, { onMediaChange: function (event) { return _this.handleMedia(event); } }),
            this.props.srLabel ? (React.createElement(SrOnly, { wrapperId: this.state.srLabelId }, this.props.srLabel)) : null,
            (this.props.mode === 'dynamic' ||
                this.props.mode === 'staticCollapsedOnMobile') &&
                this.state.visibleItemsCount === 0 &&
                ((_a = this.items()) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (React.createElement(DropdownMoreButton, { buttonId: this.getDropdownButtonId(), mode: this.props.dropdownToggleMode, size: this.props.dropdownToggleSize, srDescribedby: this.getMoreButtonDescriptionId(), i18n: this.getSrMoreLabel() })) : null,
            React.createElement("ul", { ref: this.buttonGroupItemsContainer, className: 'cg-button-group-items ' +
                    (this.props.alignment === 'left' ? 'cg-is-left-aligned ' : '') },
                Object.values(this.readTemplate('buttonGroupItem')).map(function (item, idx) {
                    return (React.createElement("li", { onClick: _this.removeSelectedDropdownItem, key: 'cogen-2975' + idx.toString(), className: _this.getItemClasses(idx) }, item));
                }),
                this.props.mode === 'dynamic' ||
                    this.props.mode === 'staticCollapsedOnMobile' ? (React.createElement("li", { ref: this.dropdownContainer, className: this.getDropdownContainerClasses() },
                    this.state.visibleItemsCount !== 0 ? (React.createElement(DropdownMoreButton, { buttonId: this.getDropdownButtonIdItemsVisible(), mode: this.props.dropdownToggleMode, size: this.props.dropdownToggleSize, srDescribedby: this.getMoreButtonDescriptionId(), i18n: this.getSrMoreLabel() })) : null,
                    this.isSelectedItemTruncated() ? (React.createElement(SrOnly, { wrapperId: this.getMoreButtonDescriptionId() }, this.props.i18n.srCurrentPageText)) : null,
                    React.createElement("div", { onClick: function (event) {
                            return _this.handleDropdownItemSelection(event);
                        }, onKeyDown: function (event) {
                            return _this.handleDropdownItemSelection(event);
                        } },
                        React.createElement(Dropdown, { targetSelector: this.getTargetSelector(), menuMode: "flyOut" },
                            this.getDropdownItems().length > 0 ? (React.createElement(DropdownList, { menuMode: "flyOut" }, Object.values(this.readTemplate('buttonGroupDropdownListItem')).map(function (item, idx) {
                                return (React.createElement(React.Fragment, { key: 'cogen-2984' + idx.toString() }, idx >= _this.state.visibleItemsCount ? (React.createElement(React.Fragment, null,
                                    React.createElement("div", { slot: "dropdownListItem" }, item),
                                    _this.props.dividerAfterItems.indexOf(idx + 1) >
                                        -1 ? (React.createElement(React.Fragment, null,
                                        React.createElement(DropdownListSeparator, { slot: "dropdownListItem" }))) : null)) : null));
                            }))) : null,
                            this.getDropdownItems().length === 0 ? (React.createElement(DropdownMenu, null, Object.values(this.readTemplate('buttonGroupDropdownItem')).map(function (item, idx) {
                                return (React.createElement(React.Fragment, { key: 'cogen-2991' + idx.toString() }, idx >= _this.state.visibleItemsCount ? (React.createElement(React.Fragment, null,
                                    item,
                                    _this.props.dividerAfterItems.indexOf(idx + 1) >
                                        -1 ? (React.createElement(DropdownMenuDivider, null)) : null)) : null));
                            }))) : null)))) : null)));
    };
    ButtonGroup.prototype.getSrMoreLabel = function () {
        return { more: this.props.i18n.srMoreLabel };
    };
    ButtonGroup.prototype.buttonGroupContainer = function () {
        return this.buttonGroupContainerRef
            ? this.buttonGroupContainerRef.current
            : null;
    };
    ButtonGroup.prototype.handleMedia = function (breakpoint) {
        this.writeState('isMobile', breakpoint === 'XS');
    };
    ButtonGroup.prototype.items = function () {
        var _a;
        var buttonGroupItemNodes = (_a = this.buttonGroupContainer()) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.cg-button-group-item');
        var items = [];
        if (buttonGroupItemNodes) {
            buttonGroupItemNodes.forEach(function (item) { return items.push(item); });
        }
        return items;
    };
    ButtonGroup.prototype.renderItems = function () {
        polyfillCustomEvent();
        var mainElement = this.buttonGroupContainer();
        var items = this.items();
        var itemsWidths = Array.from(items).map(function (item) {
            // replace on "getElementWidth" after https://jira.wolterskluwer.io/jira/browse/JUMPSTART-3741
            return _getElementWidth(mainElement.ownerDocument, item);
        });
        var buttonGroupComputedStyle = mainElement.ownerDocument.defaultView.getComputedStyle(mainElement);
        var buttonGroupWidth = parseFloat(buttonGroupComputedStyle.width);
        var allItemsLength = itemsWidths.reduce(function (sum, w) { return sum + w; }, 0);
        var visibleItemsCount = 0;
        var availableSpace = buttonGroupWidth;
        var threshold = this.props.threshold;
        var diff = Math.floor(availableSpace - allItemsLength - threshold);
        var availableSpaceLeft = diff + threshold > 0 ? diff + threshold : 0;
        var buttonGroupEmptySpaceWidth = new CustomEvent('cgButtonGroupEmptySpaceWidth', {
            bubbles: true,
            cancelable: true,
            detail: { width: availableSpaceLeft },
        });
        mainElement.dispatchEvent(buttonGroupEmptySpaceWidth);
        if (diff > 0 || this.isStatic()) {
            //show all items
            visibleItemsCount = itemsWidths.length;
        }
        else {
            //calculate how many items can be shown
            var totalLength = 0;
            availableSpace -= this.dropdownButtonWidth + threshold;
            for (var i = 0; i < itemsWidths.length; i++) {
                totalLength += itemsWidths[i];
                if (Math.floor(availableSpace - totalLength) > 0) {
                    visibleItemsCount++;
                }
                else {
                    break;
                }
            }
        }
        var isDropdownVisible = visibleItemsCount < items.length;
        this.writeState('isDropdownVisible', isDropdownVisible);
        this.writeState('dropdownLeftMarginType', this.getDropdownMarginLeftClass(visibleItemsCount, items));
        var oldItemsCount = this.state.visibleItemsCount;
        this.writeState('visibleItemsCount', visibleItemsCount);
        if (oldItemsCount !== visibleItemsCount) {
            this.emit(this.visibleItemsChange, visibleItemsCount);
        }
        this.setItemsLeftMarginTypes();
    };
    ButtonGroup.prototype.getItemClasses = function (idx) {
        var leftMargins = this.state.itemsLeftMarginTypes;
        return classNames({
            'cg-button-group-item': true,
            'cg-has-margin-left-icon': leftMargins[idx] === 'icon',
            'cg-has-margin-left-default': leftMargins[idx] === 'default',
            'cg-is-hidden': idx >= this.state.visibleItemsCount,
            'cg-button-group-separator': this.props.dividerAfterItems.indexOf(idx) > -1,
        });
    };
    ButtonGroup.prototype.getDropdownContainerClasses = function () {
        var leftMarginType = this.state.dropdownLeftMarginType;
        return classNames({
            'cg-button-group-dropdown-container': true,
            'cg-is-hidden': !this.getIsDropdownVisible() && this.props.mode === 'dynamic',
            'cg-has-margin-left-icon': leftMarginType === 'icon',
            'cg-has-margin-left-default': leftMarginType === 'default',
        });
    };
    ButtonGroup.prototype.getDropdownMarginLeftClass = function (visibleItemsCount, items) {
        if (visibleItemsCount === 0) {
            return 'none';
        }
        var lastVisibleItem = items[visibleItemsCount - 1];
        if (!lastVisibleItem) {
            return 'none';
        }
        return this.getLeftMarginTypeByElement(lastVisibleItem);
    };
    ButtonGroup.prototype.setItemsLeftMarginTypes = function () {
        var _this = this;
        var itemsLeftMarginTypes = this.items().map(function (_, idx, items) {
            if (idx === 0) {
                return 'none';
            }
            var current = _this.getLeftMarginTypeByElement(items[idx]);
            var previeous = _this.getLeftMarginTypeByElement(items[idx - 1]);
            if (current !== 'none') {
                return current;
            }
            return previeous;
        });
        this.writeState('itemsLeftMarginTypes', itemsLeftMarginTypes);
    };
    ButtonGroup.prototype.getLeftMarginTypeByElement = function (element) {
        if (element === null || element === void 0 ? void 0 : element.querySelector('.cg-button-field-text, .cg-button-field-toggle')) {
            return 'none';
        }
        if (element === null || element === void 0 ? void 0 : element.querySelector('.cg-button-field-icon')) {
            return 'icon';
        }
        return 'default';
    };
    ButtonGroup.prototype.isStatic = function () {
        return (this.props.mode === 'static' ||
            this.props.mode === 'staticCollapsedOnMobile');
    };
    ButtonGroup.prototype.setDropdownButtonWidth = function () {
        var isDropdownWidthCalculated = this.state.isDropdownWidthCalculated;
        var dropdownButton = this.dropdownContainer
            ? this.dropdownContainer.current
            : null;
        if (isDropdownWidthCalculated || this.isStatic()) {
            return;
        }
        if (dropdownButton && this.state.isDropdownVisible && !this.isStatic()) {
            this.dropdownButtonWidth = dropdownButton.offsetWidth;
            this.writeState('isDropdownWidthCalculated', true);
        }
    };
    ButtonGroup.prototype.getDropdownButtonId = function () {
        return this._dropdownButtonId;
    };
    ButtonGroup.prototype.getIsDropdownVisible = function () {
        return this.state.isDropdownVisible;
    };
    ButtonGroup.prototype.getDropdownButtonIdItemsVisible = function () {
        return this._dropdownButtonIdItemsVisible;
    };
    ButtonGroup.prototype.getTargetSelector = function () {
        if (this._dropdownButtonId && this._dropdownButtonIdItemsVisible) {
            return this.state.visibleItemsCount === 0
                ? "#".concat(this._dropdownButtonId)
                : "#".concat(this._dropdownButtonIdItemsVisible);
        }
        return DEFAULT_DROPDOWN_TARGET_SELECTOR;
    };
    ButtonGroup.prototype.getDropdownItems = function () {
        return this.readTemplate('buttonGroupDropdownListItem').slice(this.state.visibleItemsCount);
    };
    ButtonGroup.prototype.isSelectedItemTruncated = function () {
        var items = this.items();
        if (!items)
            return;
        return items.length > this.state.visibleItemsCount;
    };
    ButtonGroup.prototype.getMoreButtonDescriptionId = function () {
        return this.isSelectedItemTruncated()
            ? this.state._moreButtonDescriptionId
            : null;
    };
    ButtonGroup.prototype.handleDropdownItemSelection = function (event) {
        var _a;
        var isEnterPressed = (event === null || event === void 0 ? void 0 : event.key) === 'Enter';
        if ((event === null || event === void 0 ? void 0 : event.key) && !isEnterPressed)
            return;
        var target = event.target;
        var selectedIdx = Array.from((_a = this.buttonGroupContainer()) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[data-e2e="cg-dropdown"] [data-e2e="cg-dropdown-list-item"]')).findIndex(function (item) { return item.contains(target); }) + 1;
        if (!this.state.isMobile) {
            selectedIdx += this.state.visibleItemsCount;
        }
        if (selectedIdx === -1) {
            return;
        }
        this.writeState('_selectedDropdownItem', selectedIdx);
    };
    ButtonGroup.prototype.removeSelectedDropdownItem = function () {
        if (this.state._selectedDropdownItem === -1) {
            return;
        }
        this.writeState('_selectedDropdownItem', -1);
    };
    ButtonGroup.prototype.componentDidMount = function () {
        var _this = this;
        this.writeState('_moreButtonDescriptionId', randomId());
        this.writeState('srLabelId', randomId());
        this._dropdownButtonId = randomId();
        this._dropdownButtonIdItemsVisible = randomId();
        this.removeResizeListener = resizeListener(this.buttonGroupContainer(), this.handleResize);
        this.mutationObserver = new MutationObserver(function (entries) {
            var isProjectedContentChanged = function (mutation) {
                // check add/remove action item
                if (mutation.type === 'childList' &&
                    mutation.target.nodeType === Node.ELEMENT_NODE &&
                    _this.buttonGroupContainer().contains(mutation.target)) {
                    return true;
                }
                // check action item content
                var node = mutation.target.nodeType !== Node.ELEMENT_NODE
                    ? mutation.target.parentNode
                    : mutation.target;
                var projectedContentChanged = false;
                walkToTop(node, function (node) {
                    if (node.classList.contains('cg-button-group-item')) {
                        projectedContentChanged = true;
                        return false;
                    }
                    else if (node.classList.contains('cg-button-group')) {
                        return false;
                    }
                    return true;
                });
                return projectedContentChanged;
            };
            var result = entries.some(function (mutation) {
                return isProjectedContentChanged(mutation);
            });
            if (result) {
                _this.handleResize();
            }
        });
        this.mutationObserver.observe(this.buttonGroupItemsContainer.current, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true,
        });
        this.renderItems();
        if (!this.readTemplate('buttonGroupDropdownItem').length) {
            return;
        }
    };
    ButtonGroup.prototype.componentWillUnmount = function () {
        this.removeResizeListener();
        this.mutationObserver.disconnect();
        this.toCancel.forEach(function (cancelableFunc) {
            cancelableFunc();
        });
    };
    ButtonGroup.defaultProps = {
        slot: '',
        dataE2e: 'cg-button-group',
        threshold: 0,
        alignment: 'right',
        dividerAfterItems: [],
        mode: 'dynamic',
        dropdownToggleMode: 'blue',
        dropdownToggleSize: 'large16px',
        srLabel: '',
        i18n: {
            srMoreLabel: 'More navigation options',
            srCurrentPageText: 'Contains current page link',
        },
    };
    ButtonGroup.displayName = 'ButtonGroup';
    return ButtonGroup;
}(React.Component));
export { ButtonGroup };
